import React, { useState, useEffect, useRef } from "react";

const Title = ({ title, des }) => {
  const [isVisible, setIsVisible] = useState(false);
  const titleRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entries[0].target);
        }
      },
      {
        threshold: 0.1,
      }
    );

    const currentTitleRef = titleRef.current;
    if (currentTitleRef) {
      observer.observe(currentTitleRef);
    }

    return () => {
      if (currentTitleRef) {
        observer.unobserve(currentTitleRef);
      }
    };
  }, []);

  // Split title into words for animation
  const words = title.split(" ");

  return (
    <div className="flex flex-col gap-4 text-left mb-10" ref={titleRef}>
      <h2 className="font-display font-semibold text-lightText text-3xl leading-tight tracking-[0.02em]">
        {words.map((word, index) => (
          <span
            key={index}
            className="inline-block relative overflow-hidden mr-[8px]"
          >
            <span
              className="inline-block transform transition-all duration-700"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible
                  ? "translateY(0) scale(1)"
                  : "translateY(50px) scale(0.95)",
                filter: isVisible ? "blur(0)" : "blur(8px)",
                transitionDelay: `${index * 150}ms`,
              }}
            >
              {word}
            </span>
          </span>
        ))}
      </h2>
      {des && (
        <p
          className="font-sans font-normal text-grayText text-base leading-7 max-w-[650px]"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transitionDelay: `${words.length * 100 + 100}ms`,
          }}
        >
          {des}
        </p>
      )}
    </div>
  );
};

export default Title;
